import React, { FC } from "react";
import { Stack } from "sprint-common-web";

export const HeaderActions: FC = ({ children }) => {
    return (
        <Stack horizontal tokens={{ childrenGap: 5 }}>
            {children}
        </Stack>
    );
};
